
<template>

  <img class="block w-full max-w-[260px] mx-auto" src="../images/activity-2-part-1-tools.png" alt="Green toolbox" />

  <p class="mt-6 text-neutral-700">
    
    Not every town you pass through will be friendly toward "your kind."
    
    Packing some basic tools so you can fix your car yourself won't save you time—but it may save you some trouble.
  
  </p>

</template>
